import { Group, Text, Badge } from "@mantine/core";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import type { ColumnType } from "../../../components/AdminDataTable";
import type { AdminArticleCard } from "./types";

dayjs.locale("fr");

// Badge statut (UI-SPEC Color §B) : Brouillon gris / Publié brand.
const StatusBadge = ({ status }: { status: AdminArticleCard["status"] }) =>
  status === "published" ? (
    <Badge color="brand" variant="light">
      Publié
    </Badge>
  ) : (
    <Badge color="gray" variant="light">
      Brouillon
    </Badge>
  );

export const columns: ColumnType<AdminArticleCard>[] = [
  {
    accessor: "title",
    title: "Titre",
    sortable: true,
    // Focal point de chaque ligne (UI-SPEC) : fw={700} (REV-3, plus de fw={500}).
    render: (article) => (
      <Text size="sm" fw={700}>
        {article.title}
      </Text>
    ),
  },
  {
    accessor: "status",
    title: "Statut",
    sortable: true,
    width: 130,
    render: (article) => <StatusBadge status={article.status} />,
  },
  {
    accessor: "tags",
    title: "Tags",
    render: (article) => {
      if (!article.tags?.length)
        return (
          <Text size="xs" c="dimmed">
            —
          </Text>
        );
      return (
        <Group gap="xs">
          {article.tags.map((tag) => (
            <Badge key={tag} color="gray" variant="light" size="sm">
              {tag}
            </Badge>
          ))}
        </Group>
      );
    },
  },
  {
    accessor: "updated_at",
    title: "Mis à jour",
    sortable: true,
    width: 160,
    render: (article) => (
      <Text size="xs" c="dimmed">
        {dayjs(article.updated_at).format("DD MMMM YYYY")}
      </Text>
    ),
  },
];
